import { Navigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

export default function PublicRoute({ children }) {
  const user = useAuth();

  if (!user) {
    return children;
  } else if (user === "admin") {
    return <Navigate to="/admin/dashboard" />;
  } else if (user === "student") {
    return <Navigate to="/" />;
  }
}
